import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toast } from "sonner";

const WishlistContext = createContext(null);
const STORAGE_KEY = "noora_wishlist";

export function WishlistProvider({ children }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) setItems(JSON.parse(saved));
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const has = useCallback((slug) => items.some((i) => i.slug === slug), [items]);

  const toggle = useCallback(
    (product) => {
      setItems((prev) => {
        if (prev.some((i) => i.slug === product.slug)) {
          toast("Removed from wishlist");
          return prev.filter((i) => i.slug !== product.slug);
        }
        toast.success("Saved to wishlist");
        return [
          ...prev,
          {
            slug: product.slug,
            name: product.name,
            price: product.price,
            image: product.images ? product.images[0] : product.image,
            rating: product.rating,
          },
        ];
      });
    },
    []
  );

  const remove = useCallback((slug) => {
    setItems((prev) => prev.filter((i) => i.slug !== slug));
  }, []);

  return (
    <WishlistContext.Provider value={{ items, has, toggle, remove, count: items.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
